<template>
  <div class="screen">
    <div class="content">
      <slot />
      <div class="title">Hooray, {{ name }}!</div>
      <img class="img" src="../assets/salute.gif" alt="salute" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Greets",
  props: {
    name: String
  }
};
</script>

<style scoped>
.content {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(var(--gray-1));
  z-index: 1;
}

.title {
  display: block;
  background: rgba(var(--gray-4), 0.2);
  backdrop-filter: saturate(180%) blur(1rem);
  padding: var(--gutter);
  border-radius: var(--brs);
  text-align: center;
}

.img {
  position: absolute;
  transform: translateY(20%);
  width: 12rem;
  z-index: -1;
}

.back-greets {
  position: absolute;
  left: var(--gutter);
  top: var(--gutter);
}
</style>
